// Instituições atendidas pelo portal de eventos.
//
// Cada evento pertence a uma delas (campo Instituicao). Isso define:
//   - o domínio do link de inscrição gerado no admin;
//   - o nome/logo exibidos no cabeçalho da tela pública.
//
// `base: null` = usa o domínio em que o portal está aberto (o do colégio hoje).
// `logo` aponta para um arquivo em frontend/public (ex.: public/logo-faculdade.png).
// Se o arquivo não existir, o cabeçalho cai no ícone padrão automaticamente.
export const INSTITUICOES = {
  colegio: {
    id: "colegio",
    nome: "Colégio Santa Cruz",
    base: null,
    logo: "/logo-colegio.png",
    gradiente: "linear-gradient(135deg, #0f1b3d 0%, #3b5bdb 100%)",
  },
  faculdade: {
    id: "faculdade",
    nome: "Faculdade Católica Dom Orione",
    base: "https://eventos.catolicaorione.edu.br",
    logo: "/logo-faculdade.png",
    gradiente: "linear-gradient(135deg, #0f1b3d 0%, #3b5bdb 100%)",
  },
};

export const INSTITUICAO_PADRAO = "colegio";

/** Instituição pelo id (aceita nulo/valor desconhecido → colégio). */
export const instituicaoDe = (id) =>
  INSTITUICOES[(id || "").toLowerCase()] || INSTITUICOES[INSTITUICAO_PADRAO];

/** Domínio da instituição (ou o domínio atual, quando ela não tem um próprio). */
export const baseInstituicao = (id) =>
  instituicaoDe(id).base || window.location.origin;

/** Link público de inscrição do evento, já no domínio da instituição dele. */
export const linkEvento = (evento) =>
  `${baseInstituicao(evento?.Instituicao)}/eventos/${evento?.Id}`;

/** Instituição do domínio aberto no navegador (usada quando não há evento no link). */
export const instituicaoDoHost = () => {
  const host = window.location.host.toLowerCase();
  const achada = Object.values(INSTITUICOES).find(
    (i) => i.base && i.base.toLowerCase().includes(host)
  );
  return achada || INSTITUICOES[INSTITUICAO_PADRAO];
};
